import cx from 'classnames'
import React, { useRef, useState } from 'react'

import CTA from '@f/elements/CTA/CTA'
import Icon from '@f/elements/Icon'
import { InfoIcon } from '@f/elements/Icon/InfoIcon'

interface HelpBlockProps {
  teaser: string
  answer: string
}

export const QuizHelpBlock = ({ teaser, answer }: HelpBlockProps) => {
  const [showHelpAnswer, setShowHelpAnswer] = useState(false)
  const teaserButtonRef = useRef<HTMLDivElement>(null)

  const toggleShowHelpAnswer = () => {
    setShowHelpAnswer(show => !show)
  }

  return (
    <div className='f-d-flc f-fl-al-ce'>
      <div ref={teaserButtonRef}>
        <CTA
          type='text-primary'
          onClick={toggleShowHelpAnswer}
          className='[ f-t-body f-p-t-040 f-p-h-020 f-d-flr ]'>
          <span className='[ f-fl-no f-m-r-010 ]'>
            <InfoIcon />
          </span>
          {teaser}
          <span className='[ f-fl-no f-m-l-010 ]'>
            <Icon
              icon='down-arrow-16px'
              className={cx(
                '[ f-icon-010 f-c-st-ter ] has-animated-chevron',
                showHelpAnswer && 'is-switched'
              )}
            />
          </span>
        </CTA>
      </div>
      {showHelpAnswer && (
        <div
          className='[ f-t-body f-m-t-010 f-p-h-020:m f-p-h-010 ] QuizHelpBlock-description'
          style={{ width: teaserButtonRef.current?.offsetWidth }}>
          {answer}
        </div>
      )}
    </div>
  )
}
